import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'roofA', d: 'M-3,-3h0.5v0.5h-0.5zM-2,-2.5h1v0.5h-1zM-1,-2h0.5v0.5h-0.5z' },
    {
      paint: [
        ['roofA', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-2.5,-3h0.5v0.5h-0.5zM3,-3h1v1h-1zM-3,-2.5h1v0.5h-1zM-3,-2h0.5v2h-0.5zM-1.5,-2h0.5v0.5h-0.5zM0,-2h1.5v0.5h-1.5zM2.5,-2h1.5v0.5h-1.5zM0,-1.5h4v1.5h-4zM0,0h2.5v0.5h-2.5zM0,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['snowCap', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-2,-6.5h0.5v1h-0.5zM-2.5,-5.5h1.5v0.5h-1.5zM-3,-5h2v0.5h-2zM-3.5,-4.5h2.5v0.5h-2.5zM-4,-4h3.5v0.5h-3.5zM-3.5,-3.5h3v0.5h-3zM-3.5,-3h0.5v3h-0.5zM-2,-3h2v0.5h-2zM-1,-2.5h1v0.5h-1zM-0.5,-2h0.5v2.5h-0.5zM-2,-1h0.5v0.5h-0.5zM-3.5,0h1.5v0.5h-1.5zM2.5,0h1v0.5h-1zM-2.5,0.5h2.5v0.5h-2.5zM1.5,0.5h1.5v0.5h-1.5zM-1.5,1h3v0.5h-3zM-0.5,1.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M1,-7h1v0.5h-1zM-1.5,-6.5h4v1h-4zM-1,-5.5h4v0.5h-4zM-1,-5h4.5v0.5h-4.5zM-1,-4.5h5v0.5h-5zM-0.5,-4h4.5v0.5h-4.5zM-0.5,-3.5h3.5v0.5h-3.5zM0,-3h1.5v0.5h-1.5zM0,-2.5h0.5v0.5h-0.5zM2,-2.5h0.5v0.5h-0.5zM-2.5,-2h1v0.5h-1zM-2.5,-1.5h2v0.5h-2zM-2.5,-1h0.5v0.5h-0.5zM-1.5,-1h1v0.5h-1zM-2.5,-0.5h2v0.5h-2zM-2,0h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['shadow', 0.22],
        ['trunk', 0.78],
      ],
      d: 'M3,-3.5h1v0.5h-1zM1.5,-3h1.5v0.5h-1.5zM0.5,-2.5h1.5v0.5h-1.5zM2.5,-2.5h0.5v0.5h-0.5zM1.5,-2h1v0.5h-1z',
    },
  ],
  pixels: 213,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'roofA',
      d: 'M-4,-4h1v0.5h-1zM-4,-3.5h2v0.5h-2zM-4,-3h3v0.5h-3zM-4,-2.5h0.5v2h-0.5zM-3,-2.5h2.5v0.5h-2.5zM-1.5,-2h1v0.5h-1z',
    },
    {
      paint: [
        ['roofA', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M4,-4h0.5v0.5h-0.5zM3.5,-3.5h1v0.5h-1zM1.5,-3h0.5v0.5h-0.5zM3,-3h1.5v0.5h-1.5zM-3.5,-2.5h0.5v0.5h-0.5zM0,-2.5h4.5v2.5h-4.5zM-2,-2h0.5v0.5h-0.5zM-4,-0.5h0.5v0.5h-0.5zM0,0h3.5v0.5h-3.5zM0,0.5h2v0.5h-2zM0,1h1v0.5h-1z',
    },
    {
      paint: [
        ['roofA', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1,-3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['snowCap', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-2.5,-7.5h0.5v0.5h-0.5zM2,-7.5h0.5v0.5h-0.5zM-3,-7h1.5v0.5h-1.5zM-3.5,-6.5h2v0.5h-2zM-3.5,-6h2.5v0.5h-2.5zM-4,-5.5h3v0.5h-3zM-4.5,-5h4v1h-4zM-4.5,-4h0.5v4h-0.5zM-3,-4h3v0.5h-3zM-2,-3.5h2v0.5h-2zM-0.5,-3h0.5v1.5h-0.5zM-1,-1.5h1v0.5h-1zM-2.5,-1h0.5v0.5h-0.5zM-0.5,-1h0.5v2h-0.5zM-2,-0.5h0.5v0.5h-0.5zM-4,0h1v0.5h-1zM3.5,0h1v0.5h-1zM-3,0.5h1v0.5h-1zM2,0.5h1.5v0.5h-1.5zM-2,1h2v0.5h-2zM1,1h1.5v0.5h-1.5zM-1,1.5h2v0.5h-2z',
    },
    {
      paint: 'trunk',
      d: 'M-2,-8h3v1h-3zM2.5,-7.5h0.5v0.5h-0.5zM-1.5,-7h5v0.5h-5zM-1.5,-6.5h5.5v0.5h-5.5zM-1,-6h5v0.5h-5zM-1,-5.5h5.5v0.5h-5.5zM-0.5,-5h5.5v0.5h-5.5zM-0.5,-4.5h4.5v0.5h-4.5zM0,-4h2.5v0.5h-2.5zM0,-3.5h1.5v0.5h-1.5zM2.5,-3.5h0.5v0.5h-0.5zM0,-3h0.5v0.5h-0.5zM2,-3h0.5v0.5h-0.5zM-3.5,-2h1v0.5h-1zM-3.5,-1.5h2.5v0.5h-2.5zM-3.5,-1h1v0.5h-1zM-2,-1h1.5v0.5h-1.5zM-3.5,-0.5h1.5v0.5h-1.5zM-1.5,-0.5h1v0.5h-1zM-3,0h2.5v0.5h-2.5zM-2,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['shadow', 0.22],
        ['trunk', 0.78],
      ],
      d: 'M1.5,-9h0.5v0.5h-0.5zM1,-8.5h1.5v0.5h-1.5zM4,-4.5h1v0.5h-1zM2.5,-4h1.5v0.5h-1.5zM1.5,-3.5h1v0.5h-1zM3,-3.5h0.5v0.5h-0.5zM0.5,-3h1v0.5h-1zM2.5,-3h0.5v0.5h-0.5zM-2.5,-2h0.5v0.5h-0.5zM3.5,0.5h0.5v0.5h-0.5zM1,1.5h0.5v0.5h-0.5z',
    },
    { paint: 'fence', d: 'M-3.5,0.5h0.5v0.5h-0.5z' },
    { paint: 'wall', d: 'M1,-8h1.5v0.5h-1.5zM1,-7.5h1v0.5h-1z' },
  ],
  pixels: 312,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'wall',
      d: 'M-2.5,-2.5h0.5v0.5h-0.5zM-2.5,-2h1.5v0.5h-1.5zM-2.5,-1.5h0.5v1.5h-0.5zM-0.5,-1.5h0.5v2h-0.5z',
    },
    {
      paint: 'wallShade',
      d: 'M2,-2h1v1h-1zM0,-1.5h1v1h-1zM1.5,-1h1.5v0.5h-1.5zM0,-0.5h3v0.5h-3zM0,0h2v0.5h-2zM0,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['roofB', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1.5,-4.5h0.5v0.5h-0.5zM-2,-4h1v0.5h-1zM-2.5,-3.5h2v0.5h-2zM-3,-3h2.5v0.5h-2.5zM-2,-2.5h2v0.5h-2zM-1,-2h1.5v0.5h-1.5zM-0.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M1,-5h0.5v0.5h-0.5zM-1,-4.5h3v0.5h-3zM-1,-4h3.5v0.5h-3.5zM-0.5,-3.5h3.5v0.5h-3.5zM-0.5,-3h3v0.5h-3zM0,-2.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofB', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M2.5,-3h0.5v0.5h-0.5zM1.5,-2.5h1.5v0.5h-1.5zM0.5,-2h1.5v0.5h-1.5zM1,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-1.5,-1.5h0.5v0.5h-0.5zM1,-1.5h1v0.5h-1zM-2,-1h1.5v1h-1.5zM-1,0h0.5v0.5h-0.5zM1.5,0.5h0.5v0.5h-0.5zM0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-3,-2.5h0.5v2.5h-0.5zM-2,-1.5h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM-2.5,0h1.5v0.5h-1.5zM2,0h0.5v0.5h-0.5zM-2,0.5h1.5v0.5h-1.5zM0.5,0.5h1v0.5h-1zM-0.5,1h1v0.5h-1z',
    },
  ],
  pixels: 121,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
